import { render, staticRenderFns } from "./topicsDeclaration.vue?vue&type=template&id=bf81b0b2&scoped=true&"
import script from "./topicsDeclaration.vue?vue&type=script&lang=js&"
export * from "./topicsDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./topicsDeclaration.vue?vue&type=style&index=0&id=bf81b0b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf81b0b2",
  null
  
)

export default component.exports